<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="form-group" [ngClass]="{error: control.dirty && control.invalid}">
    <label>{{label}}</label>
    
    <input *ngIf="type !== 'textarea'" 
            [type]="type" 
            class="form-control" 
            placeholder="{{label}}"
            (keyup)="onKeyup($event.target.value)"
            [value]="inputValue"
            [disabled]="isDisabled"
            [ngClass]="{'ng-valid': control.valid, 'ng-invalid': control.invalid, 'ng-dirty': control.dirty, 'ng-empty': isInputEmpty() }"/>
    
    <textarea *ngIf="type === 'textarea'" class="form-control" 
            placeholder="{{label}}"
            rows="4"
            (keyup)="onKeyup($event.target.value)"
            [value]="inputValue"
            [disabled]="isDisabled"
            [ngClass]="{'ng-valid': control.valid, 'ng-invalid': control.invalid, 'ng-dirty': control.dirty, 'ng-empty': isInputEmpty() }"></textarea>

    
    <div class="error-message">
        <ng-container *ngFor="let error of errorMessages">
            <p class="error" *ngIf="control && control.hasError(error.key)">
                {{ error.message }}
            </p>
        </ng-container>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/input-text/input-text.component.html